export var headers = {
	"Project-Id-Version": "open-xchange-appsuite-unsubscribe",
	"Report-Msgid-Bugs-To": "",
	"POT-Creation-Date": "2021-11-04 13:46+0100",
	"PO-Revision-Date": "2020-04-30 11:13+0200",
	"Last-Translator": "",
	Language: "de_DE",
	"Language-Team": "NAME <EMAIL>",
	"Content-Type": "text/plain; charset=UTF-8",
	"Content-Transfer-Encoding": "8bit",
	"Plural-Forms": "nplurals=2; plural=(n != 1);",
	"MIME-Version": "1.0",
	"X-Generator": "Poedit 2.1.1"
};
export default {
	headers: headers,
	"\u0000Mark as spam\u0001": [
	"Als Spam markieren"
],
	"\u0000Newsletter detected\u0001Newsletters detected": [
	"Newsletter entdeckt",
	"Newsletter entdeckt"
],
	"\u0000Operation not allowed\u0001": [
	"Dieser Vorgang ist nicht erlaubt."
],
	"\u0000Report spam\u0001": [
	"Spam melden"
],
	"\u0000There was an error trying to send your unsubscribe request. Please try again later.\u0001": [
	"Beim Senden Ihrer Abmeldeanfrage ist ein Fehler aufgetreten. Versuchen Sie es später erneut."
],
	"\u0000This is a newsletter. Would you like to unsubscribe, or mark it as spam?\u0001": [
	"Dies ist ein Newsletter. Möchten Sie sich abmelden oder ihn als Spam markieren?"
],
	"\u0000Unsubscribe\u0001": [
	"Abmelden"
],
	"\u0000Unsubscribe sent.\u0001": [
	"Abmeldung gesendet."
],
	"\u0000We have detected that all of the emails selected are newsletters. They will not be marked as spam. You can mark newsletters as spam individually.\u0001": [
	"Alle E-Mails wurden als Newsletter identifiziert. Sie werden nicht als SPAM markiert. Sie können Newsletter jedoch manuell als SPAM markieren."
],
	"\u0000Your selection includes a newsletter. It will not be marked as spam. You can mark newsletters as spam individually.\u0001Your selections include a newsletter. They will not be marked as spam. You can mark newsletters as spam individually.": [
	"Ihre Auswahl beinhaltet einen Newsletter. Er wird nicht als Spam markiert. Sie können Newsletter einzeln als Spam markieren.",
	"Ihre Auswahl beinhaltet einen Newsletter. Er wird nicht als Spam markiert. Sie können Newsletter einzeln als Spam markieren."
]
};
